<div *ngIf="selectedTab" class="notifications-container anim ml-1 ml-1">
    <app-notifications-list (closeNotificationsEvent)="router.navigateByUrl(this.router.url.split('/')[1]); selectedTab = null;" [selectedTab]="selectedTab"></app-notifications-list>
</div>
<mat-drawer-container class="drawer-container anim" *ngIf="authService.userType != 'SYSTEM' && !utilityService.routeContains('notifications')">
    <mat-drawer #drawer mode="over" class="border-0" opened="false" position="end"> 
        <app-dashboard-filters *ngIf="company" [periodFrom]="params.periodFrom" [periodTo]="params.periodTo" [company]="company" (filterEvent)="filterEvent($event)" (closeFilterDrawerEvent)="toggleDrawer()"></app-dashboard-filters>
    </mat-drawer>
    <mat-drawer-content>
        <div class="main-content px-2">
            <div class="container-fluid"> 
                <div class="p-2">
                    <div class="row mt-2">
                        <div class="col text-center">
                            <button mat-button class="w-100 dashboard-filter-button outline-none" [ngClass]="{'active': selectedPeriod == 'TODAY'}" (click)="filterPeriod('TODAY')">
                                {{ 'DASHBOARD.PERIOD-TODAY' | translate}}
                            </button>
                        </div>
                        <div class="col text-center">
                            <button mat-button class="w-100 dashboard-filter-button outline-none" [ngClass]="{'active': selectedPeriod == 'WEEK'}" (click)="filterPeriod('WEEK')">
                                {{ 'DASHBOARD.PERIOD-WEEK' | translate}}
                            </button>
                        </div>
                        <div class="col text-center">
                            <button mat-button class="w-100 dashboard-filter-button outline-none" [ngClass]="{'active': selectedPeriod == 'MONTH'}" (click)="filterPeriod('MONTH')">
                                {{ 'DASHBOARD.PERIOD-MONTH' | translate}}
                            </button>
                        </div>
                        <div class="col-2 text-center">
                            <button mat-button class="w-100 dashboard-filter-button outline-none aditional" [ngClass]="{'active': filterCount > 0}" (click)="toggleDrawer()">
                                <div class="mat-button-container">
                                    <div class="d-none d-xl-flex">
                                        {{ 'DASHBOARD.ADDITIONAL-FILTERS' | translate}}
                                    </div>
                                    <div class="d-flex d-xl-none filter-icon">
                                        <mat-icon>filter_alt</mat-icon>
                                    </div>
                                    <div class="d-flex">
                                        <mat-icon>chevron_right</mat-icon>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-2" *ngIf="dashboard">
                    <!-- ORDERS_CUSTOMERS_BY_DATE -->
                    <div class="row mt-2" *ngIf="dashboard['ORDERS_CUSTOMERS_BY_DATE']?.show && dashboard['ORDERS_CUSTOMERS_TOTAL']">
                        <div class="col-12">
                            <app-orders-customers-by-date-chart [dashboardData]="dashboard['ORDERS_CUSTOMERS_BY_DATE']" [totals]="dashboard['ORDERS_CUSTOMERS_TOTAL']"></app-orders-customers-by-date-chart>
                        </div>
                    </div>
                
                    <!-- ORDERS_CUSTOMERS_BY_HOUR -->
                    <div class="row mt-2">
                        <div class="col-12 col-xl-6" *ngIf="dashboard['ORDERS_CUSTOMERS_BY_HOUR']?.show">
                            <app-orders-customers-by-hour-chart [dashboardData]="dashboard['ORDERS_CUSTOMERS_BY_HOUR']"></app-orders-customers-by-hour-chart>
                        </div>
                        <div class="col-12 col-xl-6" *ngIf="dashboard['ORDERS_CUSTOMERS_BY_MUNICIPALITY']?.show">
                            <app-orders-customers-by-municipality-chart [dashboardData]="dashboard['ORDERS_CUSTOMERS_BY_MUNICIPALITY']"></app-orders-customers-by-municipality-chart>
                        </div>
                    </div>
                
                    <!-- TOP -->
                    <div class="row mt-2" *ngIf="dashboard['TOP_PRODUCTS']?.show || dashboard['TOP_CUSTOMERS']?.show || dashboard['TOP_CATEGORIES']?.show">
                        <div class="col-12 col-md-4">
                            <app-top-categories [dashboardData]="dashboard['TOP_CATEGORIES']"></app-top-categories>
                        </div>
                        <div class="col-12 col-md-4">
                            <app-top-products [dashboardData]="dashboard['TOP_PRODUCTS']"></app-top-products>
                        </div>
                        <div class="col-12 col-md-4">
                            <app-top-customers [dashboardData]="dashboard['TOP_CUSTOMERS']"></app-top-customers>
                        </div>
                    </div>
                </div>
                <div class="p-2" *ngIf="dashboard">
                    <!-- B2B_ORDERS_BY_ORDER_STATUS -->
                    <div class="row mt-2" *ngIf="dashboard['B2B_ORDERS_BY_ORDER_STATUS']?.show">
                        <div class="col-12">
                            <app-orders-by-order-status [dashboardData]="dashboard['B2B_ORDERS_BY_ORDER_STATUS']" [dashboardDataDelivery]="dashboard['B2B_ORDERS_BY_DELIVERY_STATUS']"></app-orders-by-order-status>
                        </div>
                    </div>
                
                        <!-- B2B_ORDERS_BY_DELIVERY_STATUS -->
                    <!-- <div class="row mt-2" *ngIf="dashboard['B2B_ORDERS_BY_DELIVERY_STATUS']?.show">
                        <div class="col-12">
                            <app-orders-by-delivery-status [dashboardData]="dashboard['B2B_ORDERS_BY_DELIVERY_STATUS']"></app-orders-by-delivery-status>
                        </div>
                    </div> -->
                
                    <!-- TOP -->
                    <div class="mt-2" *ngIf="dashboard['B2B_TOP_PRODUCTS']?.show || dashboard['B2B_TOP_CATEGORIES']?.show">
                        <div class="col-12 col-md-6">
                            <app-b2b-top-categories [dashboardData]="dashboard['B2B_TOP_CATEGORIES']"></app-b2b-top-categories>
                        </div>
                        <div class="col-12 col-md-6">
                            <app-b2b-top-products [dashboardData]="dashboard['B2B_TOP_PRODUCTS']"></app-b2b-top-products>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>

<div *ngIf="authService.userType == 'SYSTEM' && !utilityService.routeContains('notifications')">
    <div class="row bg-secondary-theme py-3 mt-4">
    <div class="col-6 mx-auto">
        <img src="../../../../../assets/eurobitLogoOnBlack.png" class="img-fluid d-block m-auto mt-2 clickable dashboard-image"
            alt="Amko">
    </div>
</div>
<hr class="wsh-hr mt-4">
<div class="row">
    <div class="col-12">
        <span class="dashboard-label">{{ 'SHARED.DATE' | translate }}:</span><span class="ml-4 dashboard-value">{{ today }}</span>
    </div>
</div>
<hr class="wsh-hr">
<div class="row">
    <div class="col-12">
        <dx-data-grid #table [dataSource]="userData" [rowAlternationEnabled]="true" [showBorders]="true"
            [showRowLines]="false" [showColumnLines]="false" [hoverStateEnabled]="true"
                [allowColumnResizing]="true"
                [allowColumnReordering]="true"
                columnResizingMode="nextColumn">

            <dxi-column dataField="username" [caption]="'SHARED.USERNAME' | translate"></dxi-column>
            <dxi-column dataField="userType" [caption]="'SHARED.TYPE' | translate"></dxi-column>
            
        </dx-data-grid>
    </div>
</div>
</div>
